import React from 'react';
import PropTypes from 'prop-types';
import styles from './Badge.module.scss';

/* ────────────────────────────────────────────────────────────
 * Badge — soft-tinted pill for status / availability / category.
 *
 *   <Badge tone="success">Active</Badge>
 *
 * Prop unification (PROMPT_TEMPLATE.md §4 d2):
 *   Badge accepts both `tone` (the unified color-prop name —
 *   matches Modal sub-primitives + IconButton) and the original
 *   `variant`. `tone` wins when both are set. New code uses
 *   `tone`; the `variant` alias is kept for ~50+ existing
 *   callers and will be removed in a future cleanup PR.
 * ──────────────────────────────────────────────────────────── */

const TONE_VALUES = ['neutral', 'success', 'warning', 'danger', 'info'];

const Badge = ({ tone, variant, size, children, className }) => {
  const colorTone = tone || variant;

  const classNames = [
    styles.badge,
    styles[colorTone],
    styles[size],
    className || '',
  ]
    .filter(Boolean)
    .join(' ');

  return <span className={classNames}>{children}</span>;
};

Badge.propTypes = {
  // `tone` — unified color-prop name (preferred for new code).
  tone: PropTypes.oneOf(TONE_VALUES),
  // `variant` — original prop name, still supported.
  variant: PropTypes.oneOf(TONE_VALUES),
  size: PropTypes.oneOf(['sm', 'md']),
  children: PropTypes.node,
  className: PropTypes.string,
};

Badge.defaultProps = {
  tone: undefined,
  variant: 'neutral',
  size: 'md',
  children: null,
  className: '',
};

export default Badge;
